import { ProjectCustomerSMSItemDTO } from '../../domain/project/ProjectDTO';
import { ProjectCustomerSMSItem } from '../../domain/project/projectCustomerSMS/ProjectCustomerSMSItem';

export class ProjectCustomerSMSItemMapper {
  static toDomain(props: ProjectCustomerSMSItemDTO): ProjectCustomerSMSItem {
    const { from, enabled, body, updated_at, include_customers_url } = props;

    return ProjectCustomerSMSItem.create({
      from,
      enabled,
      body,
      updated_at,
      include_customers_url: include_customers_url,
    });
  }

  static toRepository(smsMessage: ProjectCustomerSMSItem): ProjectCustomerSMSItemDTO {
    return {
      // from: smsMessage.from,
      enabled: smsMessage.enabled,
      body: smsMessage.body,
      include_customers_url: smsMessage.include_customers_url,
    };
  }
}
